import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { Observable } from 'rxjs';
import { AddressStore, AddressState } from './address.store';
import { Address } from './models/address.model';
import { AddressType } from './models/address-type';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AddressQuery extends QueryEntity<AddressState> {
  constructor(protected store: AddressStore) {
    super(store);
  }

  /** All addresses. */
  selectAddresses(exclude?: AddressType[]): Observable<Address[]> {
    return this.selectAll().pipe(
      map(addresses =>
        addresses.filter(
          a =>
            (!exclude || !exclude.includes(a.AddressType))
        )
      ),
    );
  }
}
